import _ from "lodash";
import React from "react";
import ReqLink from "components/RequestsLink";
import types from "dictionaries/ReqTypes";
import statuses from "dictionaries/RequestStatuses";
import { isApprovedDoc } from "helpers/DocumentStatus";

export const requestStatuses = {
  pending: 1,
  approved: 2,
  rejected: 3,
  awaitingParent: 4,
  underReview: 5,
  certificationWithdrawn: 7,
  requestWithdrawn: 8,
  accepted: 10,
  completed: 11,
  saved: 17
};

export const getStatus = request => {
  return request.status || request.requeststatusid || null;
};

export const getRequestStatuses = request => {
  const status = getStatus(request);
  return {
    isPending: isPending(status),
    isApproved: isApproved(status),
    isRejected: isRejected(status),
    isUnderReview: isUnderReview(status),
    isCertWithdrawn: isCertWithdrawn(status),
    isRequesttWithdrawn: isRequesttWithdrawn(status),
    isAccepted: isAccepted(status),
    isCompleted: isCompleted(status),
    isSaved: isSaved(status)
  };
};

export const isPending = status => {
  return status === requestStatuses.pending;
};

export const isApproved = status => {
  return status === requestStatuses.approved;
};

export const isRejected = status => {
  return status === requestStatuses.rejected;
};

export const isUnderReview = status => {
  return status === requestStatuses.underReview;
};

export const isCertWithdrawn = status => {
  return status === requestStatuses.certificationWithdrawn;
};

export const isRequesttWithdrawn = status => {
  return status === requestStatuses.requestWithdrawn;
};

export const isAccepted = status => {
  return status === requestStatuses.accepted;
};

export const isCompleted = status => {
  return status === requestStatuses.completed;
};

export const isSaved = status => {
  return status === requestStatuses.saved;
};

export const getStatusTitle = status => {
  if (_.has(statuses, status)) {
    return statuses[status].title;
  }

  return "n/a";
};

export const getFilteredRequests = (status, requests) => {
  switch (status) {
    case requestStatuses.saved:
      return _.filter(requests, req => {
        if (req.requeststatusid) {
          return isSaved(req.requeststatusid);
        }
      });
    case requestStatuses.requestWithdrawn:
      return _.filter(requests, req => {
        if (req.requeststatusid) {
          return isRequesttWithdrawn(req.requeststatusid);
        }
      });
    default:
      return _.filter(requests, req => {
        if (req.requeststatusid) {
          return (
            isPending(req.requeststatusid) || isUnderReview(req.requeststatusid)
          );
        }
      });
  }
};

export const getRequestsCount = requests => {
  return _.map(requests).length;
};

export const isInitial = type => {
  return type === types.initial;
};

export const isEco = type => {
  return type === types.eco;
};

export const isRebrand = type => {
  return type === types.rebrand;
};

export const getRequestTypeTitle = type => {
  switch (type) {
    case types.initial:
      return "Initial Certification Request";
    case types.eco:
      return "ECO Certification Request";
    case types.rebrand:
      return "Rebrand Certification Request";
    default:
      return "Unknown Request Type";
  }
};

export const renderRequestLink = (id, tn, showAsLink) => {
  if (!showAsLink) return tn;
  return <ReqLink linkTitle={tn} requestId={id} />;
};

export const formatTransactionNumber = (value, size = 5) => {
  const strVal = String(value);
  const diffLength = size - strVal.length;

  if (diffLength === 0) return strVal;

  const leadingZeroes = _.repeat("0", diffLength);

  return `${leadingZeroes}${strVal}`;
};

export const getRequestStatusGroup = (status = requestStatuses.pending) => {
  const {
    pending,
    underReview,
    requestWithdrawn,
    saved,
    awaitingParent
  } = requestStatuses;
  /*
    1 - pending requests
    5 - under review
    8 - withdrawn
    17 - saved
  */
  switch (status) {
    case pending:
      return [pending, underReview, awaitingParent];
    case requestWithdrawn:
      return [requestWithdrawn];
    case saved:
      return [saved];
    default:
      return [pending, underReview, awaitingParent];
  }
};

export const hasUploadedManual = request => {
  if (!request || !request.usersManual || !request.usersManual.document)
    return false;

  return request.usersManual.document.documentstatusid > 0;
};

export const hasUsersManualApproved = usersManual => {
  if (!usersManual || !usersManual.document) return false;
  return isApprovedDoc(usersManual.document.documentstatusid);
};

export const hasManualFile = request => {
  if (!request || !request.usersManual) return false;

  return !_.isUndefined(request.usersManual.file);
};

export const hasSupDocs = request => {
  if (!request || !request.supportDocs) return false;

  const idExists = doc => {
    return !_.isUndefined(doc.id);
  };

  return _.some(request.supportDocs, idExists);
};

export const needHideActions = requestList => {
  if (!requestList) return true;

  return _.every(requestList, { ismanualpending: 0, nreportspending: 0 });
};

export const hasStringValue = (request, fieldName) => {
  if (!request || !fieldName) return false;
  if (!_.has(request, fieldName)) return false;

  const strValue = request[fieldName].toString();
  return strValue.length > 0;
};

export const submissionTypes = [
  {
    link: "initial",
    title: "Initial Certification Request",
    hint:
      "The Initial Certification Request is the first certification request for a device"
  },
  {
    link: "eco",
    title: "ECO Certification Request",
    hint:
      "The ECO Certification Request is for HW/SW updates of a device already submitted or certified"
    // locked: true
  }
  // ,
  // {
  //   link: "rebrand",
  //   title: "Rebrand Certification Request",
  //   hint:
  //     "The Rebrand Certification Request is for rebranded device already certified"
  // }
];



// WEBPACK FOOTER //
// ./src/helpers/RequestHelper.js